import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-div-inner-html',
    templateUrl: './div-inner-html.component.html',
    styleUrl: './div-inner-html.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DivInnerHtmlComponent {

    @Input()
    html = "";
    @Input()
    styleClass = "";

}
